import React from "react";
import { Radio, ConfigProvider } from "antd";

import { Colors } from "../../config";

const VerticalRadio = (props) => {
  return (
    <ConfigProvider
      theme={{
        token: { colorPrimary: Colors.main, colorBorder: Colors.main },
      }}
    >
      <Radio.Group {...props} buttonStyle="solid">
        <div className="flex flex-col gap-3">
          {props?.items?.map((item, index) => (
            <Radio value={item.value} key={index} className="font-semibold">
              {item?.label}
            </Radio>
          ))}
        </div>
      </Radio.Group>
    </ConfigProvider>
  );
};
export default VerticalRadio;
